function getFullName(name) {
    if (name.middleName) {
        return `${name.firstName} ${name.middleName} ${name.lastName}`;
    }
    else {
        return `${name.firstName} ${name.lastName}`;
    }
}
function hasUploaded(entity, type) {
    return entity.requiredDocs.some(doc => doc.uploadType === type && doc.uploaded);
}
function mapEntity(entity, index) {
    const hasCompletedSetup = entity.hasCompletedSetup;
    // If id upload is pending, hasCompletedSetup will be true
    const hasUploadedId = hasCompletedSetup || hasUploaded(entity, 'PhotoId');
    const shouldVerify = entity.shouldVerify;
    return {
        address: entity.address,
        code: entity.code,
        isPrimary: index === 0,
        hasCompletedPersonalDetails: entity.hasCompletedPersonalDetails,
        hasCompletedSetup,
        hasUploadedId,
        hasUploadedPOA: hasUploaded(entity, 'ProofOfResidence'),
        name: getFullName(entity.name),
        verification: {
            canUseJumio: shouldVerify && !!entity.jumioVerification && entity.jumioVerification.remainingAttempts > 0,
            canUseMail: shouldVerify && entity.postVerificationRequired,
            canUsePostIdent: shouldVerify && entity.postidentVerificationRequired,
            jumio: entity.jumioVerification,
            pendingJumio: !!entity.jumioVerification && entity.jumioVerification.pendingVerifications > 0,
            verified: entity.verified,
        },
    };
}
export class GmwSetup {
    constructor(promiseCache, HoldingApi, HoldingUser) {
        this.promiseCache = promiseCache;
        this.HoldingApi = HoldingApi;
        this.HoldingUser = HoldingUser;
        this.completeSetup = () => {
            const promise = this.HoldingApi.post('verification/submit');
            return promise.then(({ holdingPermissions }) => {
                this.HoldingUser.init(holdingPermissions);
                this.promiseCache.remove('hasCompletedSetup');
                this.promiseCache.remove('needsVerification');
                this.promiseCache.remove('setupStatus');
            });
        };
        this.hasCompletedSetup = () => {
            return this.promiseCache({
                ttl: -1,
                key: 'hasCompletedSetup',
                promise: () => this.getSetupStatus().then(setupData => setupData.verificationSubmitted),
            });
        };
        this.getSetupStatus = bustCache => {
            return this.promiseCache({
                bustCache,
                ttl: -1,
                key: 'setupStatus',
                promise: () => this.HoldingApi.get('verification', { ignore403: true }).then((result) => {
                    const entities = result.entities.map(mapEntity);
                    const hasCompletedSetup = entities.every(e => e.hasCompletedSetup);
                    return {
                        additionalVerificationRequested: result.additionalVerificationRequested,
                        emails: result.emails,
                        entities,
                        expectedUse: result.expectedUse,
                        hasCompletedSetup,
                        isFullHolding: result.isFullHolding,
                        remainingOwners: result.remainingOwners,
                        verificationSubmitted: result.verificationSubmitted,
                        verified: result.verified,
                    };
                }),
            });
        };
        this.needsVerification = () => {
            return this.promiseCache({
                ttl: -1,
                key: 'needsVerification',
                promise: () => this.getSetupStatus().then(setupData => {
                    return (setupData.isFullHolding &&
                        setupData.hasCompletedSetup &&
                        setupData.additionalVerificationRequested);
                }),
            });
        };
    }
    addOwner(addEntityRequest) {
        return this.HoldingApi.post('verification/add', addEntityRequest);
    }
    updateExpectedUse(data) {
        return this.HoldingApi.post('verification/expectedUse', data);
    }
    uploadId(file, metadata) {
        return this.HoldingApi.upload('verification/upload', file, metadata);
    }
    uploadPor(file, metadata) {
        return this.HoldingApi.upload('verification/upload', file, metadata);
    }
    verifyProfile(data) {
        return this.HoldingApi.post('verification/verify', data);
    }
}
GmwSetup.$inject = ['promiseCache', 'HoldingApi', 'HoldingUser'];
angular.module('app.holding.dashboard.onboarding').service('GmwSetup', GmwSetup);



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/services/setup.ts